module.exports = __webpack_public_path__ + "img/1700_YR_2022_Background.8c574980.png";